import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface QuantityStepperProps {
  value: number;
  max: number;
  onChange: (value: number) => void;
  size?: 'sm' | 'md';
  min?: number;
  label?: string;
}
export function QuantityStepper({
  value,
  max,
  onChange,
  size = 'md',
  min = 1,
  label = 'Quantité'
}: QuantityStepperProps) {
  const h = size === 'sm' ? 'h-9' : 'h-12';
  const w = size === 'sm' ? 'w-8' : 'w-11';
  return <div className={`inline-flex ${h} items-center rounded-full border border-line bg-card`} role="group" aria-label={label} data-id="element-623" data-mp="141i6olnhek6c">
      <button type="button" onClick={() => onChange(value - 1)} disabled={value <= min} aria-label="Diminuer la quantité" className={`flex ${h} ${w} items-center justify-center rounded-full text-ink transition-colors duration-150 hover:bg-shell disabled:opacity-30`} data-id="element-624" data-mp="180930qk4hxse">
        <MinusIcon className="h-3.5 w-3.5" data-id="element-625" data-mp="3jruwq8dr6ott" />
      </button>
      <span className="min-w-[1.75rem] text-center text-sm font-medium tabular-nums" aria-live="polite" data-id="element-626" data-mp="3jtfq3uoc01q3">
        {value}
      </span>
      <button type="button" onClick={() => onChange(value + 1)} disabled={value >= max} aria-label="Augmenter la quantité" className={`flex ${h} ${w} items-center justify-center rounded-full text-ink transition-colors duration-150 hover:bg-shell disabled:opacity-30`} data-id="element-627" data-mp="19j5i3hxrb2rc">
        <PlusIcon className="h-3.5 w-3.5" data-id="element-628" data-mp="1wj37mz0ev91v" />
      </button>
    </div>;
}